import {gql} from "@apollo/client";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";
import {
    ClientReturnsTransferRequestInput
} from "../../offer-at-risk/client-return-transfer/ClientTransferReturnRequestFormAuthModal";


const GRAPHQL_MUTATION = gql`
mutation submitAuthClientReturnsTransferReq($input: ClientReturnsTransferRequestInput, $isDraft: Boolean) {
    submitAuthClientReturnsTransferReq(input: $input, isDraft: $isDraft) {
        guid
    }
}`;

type AuthClientReturnsTransferReqInput = ClientReturnsTransferRequestInput & {
    authorizationGuid: string;
}

export function useAuthClientReturnsTransfer(authorizationGuid: string) {
    const {execute,} = useMutation$<{ input: AuthClientReturnsTransferReqInput, isDraft: boolean }, void>(GRAPHQL_MUTATION);
    const submitClientReturnsTransferReq = useCallback(async function (formValues: ClientReturnsTransferRequestInput | null, isDraft: boolean = false) {
        if (formValues == null) {
            return;
        }

        try {
            await execute({
                variables: {
                    input: {
                        ...formValues,
                        authorizationGuid,
                    },
                    isDraft,
                }
            });
            showToast.success(isDraft ? 'Successfully Saved Client Returns Transfer Request as Draft' : 'Client Return/Transfer request successfully submitted. The Request can be tracked in the "Submitted Requests" section and a request number ID will be available shortly.');
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit reason by ${errors.message || errors[0].message}`);
            }
        }
    }, [authorizationGuid, execute]);

    return {
        submitClientReturnsTransferReq
    }
}
